import Api from "./Api";
import Api_2 from "./Api_extra";
import { createQueryString } from "./ApiHelper";

export default {
  GetFnBList(payload) {
    return Api().post("/pos/admin/getfnbitems", payload);
  },
  AddRawMaterial(payload) {
    return Api().post("/raw-material", payload);
  },
  UpdateRawMaterial(payload) {
    return Api().put("/raw-material", payload);
  },
  AddVendor(payload) {
    return Api().post("/vendors", payload);
  },
  AddRawMaterialCategory(payload) {
    return Api().post("/raw_material_categories", payload);
  },
  UpdateRawMaterialCategory(payload) {
    return Api().put("/raw_material_categories", payload);
  },
  UpdateVendor(payload) {
    return Api().put("/vendors", payload);
  },
  GetAllVendorMapping(payload) {
    return Api().get(
      "/ln_vendor_mapping?limit=" +
        payload.limit +
        "&currentPage=" +
        payload.currentPage
    );
  },
  AddVendorMapping(payload) {
    return Api().post("/ln_vendor_mapping", payload);
  },
  UpdateVendorMapping(payload) {
    return Api().put("/ln_vendor_mapping", payload);
  },
  AddPurchaseOrder(payload) {
    return Api().post("/purchase_orders", payload);
  },
  ApprovePurchaseOrder({ po_id }) {
    return Api().post(`/purchase_orders/approve`, { po_id });
  },
  GetAllPurchaseOrders(payload) {
    return Api().get(
      "/purchase_orders?limit=" +
        payload.limit +
        "&currentPage=" +
        payload.currentPage +
        "&searchValue=" +
        payload.searchValue +
        "&fromDate=" +
        payload.fromDate +
        "&toDate=" +
        payload.toDate +
        `&cinema_id=${payload.cinema_id}` +
        `&isExcel=${payload.isExcel}` +
        `&searchFilter=${payload.searchFilter}`
    );
  },
  UpdatePurchaseOrder(payload) {
    return Api().put("/purchase_orders", payload);
  },

  AddInvoice(payload) {
    return Api().post("/invoice", payload);
  },
  UpdateInvoice(payload) {
    return Api().put("/invoice", payload);
  },
  GetAllInvoices(payload) {
    return Api().get(
      "/invoicelist?limit=" +
        payload.limit +
        "&currentPage=" +
        payload.currentPage +
        "&searchValue=" +
        payload.searchValue +
        `&cinema_id=${payload.cinema_id}&filter_is_active=${payload.filterIsActive}`
    );
  },
  GetInvoiceDetails(payload) {
    return Api().get(`/invoice_details/${payload.i_id}`);
  },

  AddFoodCategory(payload) {
    return Api().post("/food_categories", payload);
  },
  UpdateFoodCategory(payload) {
    return Api().put("/food_categories", payload);
  },
  GetSingleFoodCategory(payload) {
    return Api().get(`/food_categories/${payload.fc_id}`);
  },
  AddRecipe(payload) {
    return Api().post("/recipes", payload);
  },
  UpdateRecipe(payload) {
    return Api().put("/recipes", payload);
  },
  GetRecipe(payload) {
    return Api().get(`/recipe/${payload.recipe_id}`);
  },
  GetAllFnBItems(payload) {
    const { cinema_id } = payload;
    let url = `/fnb_items?searchValue=${payload.searchValue}`;
    let withPricing =
      payload.hasOwnProperty("withPricing") && payload.withPricing
        ? true
        : false;
    payload &&
    payload.hasOwnProperty("limit") &&
    payload.hasOwnProperty("currentPage")
      ? (url += `&limit=${payload.limit}&currentPage=${
          payload.currentPage
        }&columnName=${payload.columnName}&orderBy=${
          payload.orderBy
        }&cinema_id=${cinema_id}&filter_is_active=${
          payload.filterIsActive
        }&non_sellable_filter=${payload.non_sellable_filter ||
          null}&category_id=${payload.category_id}&withPricing=${withPricing}`)
      : "";
    return Api().get(url);
  },
  GetFnbItem(payload) {
    let queryExt = ``;
    if (payload.hasOwnProperty("onlyActive") && payload.onlyActive == "Y") {
      queryExt = `?onlyActive=${payload.onlyActive}`;
    }
    return Api().get(`/fnb_items/${payload.item_code}${queryExt}`);
  },
  AddFnbItem(payload) {
    return Api().post("/fnb_items", payload);
  },
  UpdateFnbItem(payload) {
    return Api().put("/fnb_items", payload);
  },
  GetVendorMappingDetails(payload) {
    const query = createQueryString(payload);
    return Api().get(`/ln_vendor_mapping/${payload.vendor_id}${query}`);
  },
  GetVendorRateDetails(payload) {
    return Api().get(`/vendor_rates/${payload.vendor_id}`);
  },
  GetPurchaseOrderDetails(payload) {
    return Api().get(`/purchase_orders/${payload.po_id}`);
  },
  GetAllStockIn(payload) {
    return Api().get(
      `/stock_in?limit=${payload.limit}&currentPage=${
        payload.currentPage
      }&searchValue=${payload.searchValue}&cinema_id=${
        payload.cine_id
      }&isExcel=${payload.isExcel || "N"}&fromDate=${payload.fromDate}&toDate=${
        payload.toDate
      }${payload.groupByPoIdOnly ? "&groupByPoIdOnly=true" : ""}
      ${payload.vendor_id ? `&vendor_id=${payload.vendor_id}` : ""}
      ${payload.export_type ? `&export_type=${payload.export_type}` : ""} `
    );
  },
  GetAllStock(payload) {
    if (payload && payload.hasOwnProperty("searchValue")) {
      return Api().post(
        `/stock?searchValue=${payload.searchValue}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`,
        payload
      );
    } else {
      return Api().post(`/stock`, payload);
    }
  },
  GetAllFnbWastages(cinema_id, payload) {
    return Api().post(
      `/fnb_wastages?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&filter_is_active=${payload.filterIsActive}`,
      cinema_id
    );
  },
  GetStockInDetails(payload) {
    return Api().get(`/stock_in/${payload.po_id}/${payload.rm_id}`);
  },
  getUomFromRawMaterial(payload) {
    return Api().post("/getuomrawmaterial", payload);
  },
  GetSumStockInDetails(payload) {
    return Api().get(`/sum_stock_in/${payload.po_id}/${payload.rm_id}`);
  },
  GetUomForStockIn(payload) {
    return Api().post(`/stock_in_details`, payload);
  },
  updatStockinDetails(payload) {
    return Api().put(`/stock_in_edit`, payload);
  },
  updatStockinDetailsV2(payload) {
    return Api().put(`/stock_in_edit_v2`, payload);
  },
  //
  GetGrnList(payload) {
    return Api().post(
      `/get_grn_list?limit=${payload.limit}&currentPage=${payload.currentPage}`,
      payload
    );
  },
  GetPurchaseOrderPdf(payload) {
    return Api().post(
      `/download-purchase-order`,
      payload
    );
  },
  sendInvoiceToVendor(payload) {
    return Api().post("/send_invoice_via_email", payload);
  },
  updatStockDetails(payload) {
    return Api().post(`/stock_in_edit`, payload);
  },
  GetItemsCostPrice(payload) {
    return Api().post(`/get_items_cost_price`, payload);
  },
  //Rate Card
  GetRatecardsList(payload) {
    let url = `/api/admin/fnb_rate_cards`;
    payload &&
    payload.hasOwnProperty("limit") &&
    payload.hasOwnProperty("currentPage")
      ? (url += `?limit=${payload.limit ? payload.limit : null}&currentPage=${
          payload.currentPage ? payload.currentPage : null
        }`)
      : "";
    return Api().get(url);
    // return Api().get('/api/admin/fnb_rate_cards?limit=' + payload.limit ? payload.limit : null + '&currentPage=' + payload.currentPage ? payload.currentPage : null)
    // return Api().get('/api/admin/fnb_rate_cards?limit=' + payload.limit ? payload.limit : null + '&currentPage=' + payload.currentPage ? payload.currentPage : null)
  },
  GetRatecardById(payload) {
    return Api().get(`/api/admin/fnb_rate_cards/${payload.id}`);
  },
  AddRatecard(payload) {
    return Api().post(`/api/admin/fnb_rate_cards`, payload);
  },
  UpdateRatecard(payload) {
    return Api().put(`/api/admin/fnb_rate_cards/${payload.id}`, payload);
  },
  GetAllFnBPricing(cinema_id, payload) {
    return Api().post(
      `/fnb_pricing?limit=${payload.limit}&currentPage=${payload.currentPage}`,
      cinema_id
    );
  },
  GetFnbPricing(payload) {
    return Api().get(`/fnb_pricing/${payload.fp_id}`);
  },
  AddFnbPricing(payload) {
    return Api().post(`/ms_fnbprice`, payload);
  },
  UpdateFnbPricing(payload) {
    return Api().put(`/ms_fnbprice`, payload);
  },
  AddFnbWastage(payload) {
    return Api().post(`/fnb_wastage`, payload);
  },
  AddPreparedItemWastage(payload) {
    return Api().post(`/fnb_wastage_item`, payload);
  },
  UpdateFnbWastage(payload) {
    return Api().put(`/fnb_wastage`, payload);
  },
  GetFnbWastageDetails(payload) {
    return Api().get(`/fnb_wastages/${payload.fw_id}`);
  },
  addToPhysicalStock(payload) {
    return Api().post(`/physical_stock`, payload);
  },
  AddAllPhysicalStock(payload) {
    return Api().post(`/add_all_physical_stock`, payload);
  },
  GetStockTakeLogs(payload) {
    return Api().post(`/stock_take_logs`, payload);
  },
  GetStockTakeLogSummary(payload) {
    return Api().post(`/stock_take_summary`, payload);
  },
  //concession_stock
  GetAllConcessionStocks(cinema_id, payload) {
    return Api().post(
      `/concession_stocks?limit=${payload.limit}&currentPage=${payload.currentPage}`,
      cinema_id
    );
  },
  GetAllStoreStock(payload) {
    let url = `/store_stocks?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`;
    if (payload.rmc_id) {
      url += `&rmc_id=${payload.rmc_id}`;
    }
    return Api().post(url, payload);
  },
  GetCinemaStocks(payload) {
    return Api().post("/cinema_stocks", payload);
  },
  AddConcessionStock(payload) {
    return Api().post("/concession_stock", payload);
  },
  UpdateConcessionStock(payload) {
    return Api().put("/concession_stock", payload);
  },
  GetConcessionStock(payload) {
    return Api().get(`/concession_stocks/${payload.cstock_id}`);
  },
  GetItemCostPrice(payload) {
    return Api().get(
      `/item_cost_price?limit=${payload.limit}&currentPage=${payload.currentPage}`
    );
  },
  AddItemCostPrice(payload) {
    return Api().post(`/item_cost_price`, payload);
  },
  GetItemCostPriceById(payload) {
    return Api().get(`/item_cost_price/${payload.itc_id}`);
  },
  EditItemCostPrice(payload) {
    return Api().put(`/item_cost_price`, payload);
  },
  AddStoreManagement(payload) {
    return Api().post(`/store_management`, payload);
  },
  UpdateStoreManagement(payload) {
    return Api().put(`/store_management`, payload);
  },
  GetStoreManagementDetails(payload) {
    return Api_2().post(`/store_management_details`, payload);
  },
  GetStores(payload = {}) {
    const query = createQueryString(payload);
    return Api().get(`/store_management${query}`);
  },
  GetStoreBasedQuantity(payload) {
    return Api().post(`/store_based_quantity`, payload);
  },
  GetRawMaterialBasedQuantity(payload) {
    return Api().post(`/raw_material_quantity_in_stock`, payload);
  },
  GetRemainingQuantity(payload) {
    return Api().post(`/remaining_stock_in_quantity`, payload);
  },
  GetRawMaterialQtyAndPrice(payload) {
    return Api().post(`/raw_material_quantity_and_price`, payload);
  },
  TransferStock(payload) {
    return Api().post(`/transfer_stock`, payload);
  },
  //
  TransferStockLogs(payload) {
    return Api().post(
      `/transfer_stock_log?limit=${payload.limit}&currentPage=${payload.currentPage}`,
      payload
    );
  },
  // GOODS RETURN
  AddGoodsReturn(payload) {
    return Api().post(`/add_goods_return`, payload);
  },
  GetAllGoodsReturn(payload) {
    if (
      payload &&
      payload.hasOwnProperty("limit") &&
      payload.hasOwnProperty("currentPage")
    ) {
      return Api().post(
        `/get_all_goods_return?limit=${payload.limit}&currentPage=${payload.currentPage}`,
        payload
      );
    } else {
      return Api().post(`/get_all_goods_return`, payload);
    }
  },
  GetVendorList(payload) {
    return Api().get(
      `/get_vendor_list?limit=${payload.limit}&currentPage=${payload.currentPage}&searchValue=${payload.searchValue}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&cinema_id=${payload.cinema_id}&filter_is_active=${payload.filter_is_active}`
    );
  },
  GetRecipeList(payload) {
    return Api().get(
      `/get_recipe_list?limit=${payload.limit}&currentPage=${payload.currentPage}&searchValue=${payload.searchValue}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&filter_is_active=${payload.filterIsActive}&type=${payload.type}`
    );
  },
  BookingSources() {
    return Api().get(`/bookingsources`);
  },
  GetFnBTransactions(payload) {
    return Api_2().post(
      `/fnbtransactions?limit=${payload.limit}&currentPage=${payload.currentPage}`,
      payload
    );
  },
  GetFnBPosTransactions(payload) {
    return Api().post(
      `/pos/fnbtransactions?limit=${payload.limit}&currentPage=${payload.currentPage}`,
      payload
    );
  },
  GetFnBTransactionDetails(payload) {
    return Api().get(`/fnbtransactiondetails?ft_id=${payload.ft_id}`);
  },
  GetFnBAppTransactions(payload) {
    return Api().post(
      `/fnbapptransactions?limit=${payload.limit}&currentPage=${payload.currentPage}`,
      payload
    );
  },
  GetFnBAppTransactionDetails(payload) {
    return Api().get(`/fnbapptransactiondetails?ft_id=${payload.ft_id}`);
  },
  SearchFnbOrder(payload) {
    return Api().post(`/SearchFnbOrder`, payload);
  },
  GetFnbOrder(payload) {
    return Api().post(`/getfnborder`, payload);
  },
  GetFnbOrderEjs(payload) {
    let isReprint = payload.hasOwnProperty("isReprint")
      ? payload.isReprint
      : false;
    return Api_2().get(
      `/generate-fnb/${payload.OrderCode}/${payload.Type}/${payload.UserID}?isReprint=${isReprint}`
    );
  },
  GetFnbOrderSecurityEjs(payload) {
    let isReprint = payload.hasOwnProperty("isReprint")
      ? payload.isReprint
      : false;
    return Api().get(
      `/generate-secuirty-ticket-fnb/${payload.OrderCode}/${payload.UserID}/${payload.cinemaId}?isReprint=${isReprint}`
    );
  },

  GetFnbRefundEjs(payload) {
    let isReprint = payload.hasOwnProperty("isReprint")
      ? payload.isReprint
      : false;
    let isRefund = payload.hasOwnProperty("isRefund")
      ? payload.isRefund
      : false;
    return Api_2().get(
      `/generate-fnb-refund/${payload.OrderCode}/${payload.Type}/${payload.UserID}?isReprint=${isReprint}&isRefund=${isRefund}`
    );
  },
  /**
   * CUSTOMIZATION
   */
  GetCustomizationList(payload) {
    return Api().get(
      `/customization?limit=${payload.limit}&currentPage=${payload.currentPage}&searchKey=${payload.searchKey}&searchValue=${payload.searchValue}&cinema_id=${payload.cinema_id}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&filter_is_active=${payload.filterIsActive}`
    );
  },
  GetActiveCustomizationList(payload) {
    return Api().get(`/all_active_customization`);
  },
  AddCustomization(payload) {
    return Api().post(`/customization`, payload);
  },
  UpdateCustomization(payload) {
    return Api().put(`/customization`, payload);
  },
  GetCustomizationDetails(payload) {
    return Api().get(`/customization/${payload.customization_common_id}`);
  },
  GetCustomizationDetailsV2(payload) {
    return Api().get(`/api/pos/v2/customization/${payload.item_id}`);
  },
  GetCustomizationAdditionalCharges(payload) {
    return Api().get(
      `/get-customization-additionalcharges/${payload.customization_id}`
    );
  },
  GetAlternateItems() {
    return Api().get(`/alternateitems`);
  },
  GetAssignedAlternateItems(payload) {
    return Api().get(`/assignedalternateitems/${payload.item_code}`);
  },
  GetFoodCategories(payload) {
    const query = createQueryString(payload);
    return Api().get(`api/admin/food-categories${query}`);
  },
  UpdateCategoryOrder(payload) {
    return Api().post(`api/admin/updateFoodCategoryOrder`, payload);
  },
  GetRawMaterialsList(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/raw-material${query}`);
  },
  GetRawMaterialCategories(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/raw-material-categories${query}`);
  },
  GetFnbCategoriesLabels() {
    // const query = createQueryString(payload);
    return Api().get(`/api/admin/food-categories-label`);
  },
  UpdateFnbItemStatus(payload) {
    // const query = createQueryString(payload);
    return Api().put(`/api/admin/update_fnbitem_status`, payload);
  },
  CopyFnbMenuPriceByCinema(payload) {
    return Api().post(`/api/admin/copy-fnb-menu/${payload.cinema_id}`, payload);
  },
  GetComboDetails(payload) {
    return Api().get(`/api/admin/fnb_combo_details/${payload.item_id}`);
  },
  GetFnbStations() {
    return Api().get(`/pos/admin/getFnbStations`);
  },
  addeditvipFnb(payload) {
    return Api().post(`/api/admin/add_edit_vip_fnb`, payload);
  },
  GetVipFnb(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/get_vip_fnb${query}`);
  },
  GetModifierById(payload) {
    return Api().get(`/api/admin/get_modifier_category/${payload.category_id}`);
  },
  GetAllModifiersCategories(payload) {
    return Api().post(`/api/admin/get_modifier_category`, payload);
  },
  GetAllActiveModifiersCategories(payload) {
    return Api().get(`/api/admin/get_active_modifier_category`);
  },
  GetActiveModifiersCategoriesDetails(payload) {
    return Api().post(`/api/admin/get_modifier_categories_details`, payload);
  },
  AddEditModifierCategory(payload) {
    return Api().post(`/api/admin/modifier_category`, payload);
  },
  GetFnbModifierDetails(payload) {
    return Api().post(`/api/admin/get_fnb_modifier_details`, payload);
  },
  GetAllTaxSettings() {
    return Api().get(`/api/admin/all_tax_settings`);
  },
  GetFnBTransactionsV2(payload) {
    const query = createQueryString(payload);
    return Api_2().get(`/api/admin/reports/v2/fnbtransactionsexcel/${query}`);
  },
  getStoreRawMaterialQuantity(payload) {
    return Api().post(`/get-store-raw-material-quantity`, payload);
  },
  getPropertyInOutLogs(payload) {
    return Api().post(`/api/admin/getPropertyInOutLogs`, payload);
  },
  AddPropertyInOut(payload) {
    return Api().post(`/api/admin/createPropertyInOutLog`, payload);
  },
  GetPropertyInOutAuditLogs(payload) {
    return Api().post(`/api/admin/propertyInOutAuditLogs`, payload);
  },
  CloseTheGrnManually(payload) {
    return Api().post(`/api/admin/closeGrnPartially`, payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/PosFnbService.js